import { useQuery } from '@apollo/client'

import { CROPS, Crops, CropsVariables, Crop } from 'api'

interface Props {
  all?: boolean
}

export const useCrops = ({ all }: Props = {}) => {
  const { data, loading } = useQuery<Crops, CropsVariables>(CROPS, {
    variables: { all },
  })

  return {
    crops: data?.crops.results,
    loading,
  }
}

export type { Crop }
